import { Copyright, Building } from "lucide-react";
import ContactInfo from "./ContactInfo";
import { contactDetails, footerLinks } from "./Data";
import FooterLinkColumn from "./FooterLinkColumn";

const FooterSection = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-[#061525] text-blue-100 font-sans">
      <div className="max-w-7xl mx-auto px-6 py-16 sm:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-5 lg:gap-8">
          <div className="lg:col-span-2">
            <img
              src="DronePlanet_Logo.png"
              alt="Drone Planet Logo"
              className="w-48 mb-6"
            />
            <h3 className="text-lg font-semibold text-white">
              Join Our Newsletter
            </h3>
            <p className="mt-2 mb-6 text-blue-200 leading-relaxed max-w-md">
              Get the latest updates, exclusive offers, and drone industry news
              delivered straight to your inbox.
            </p>
            <form
              className="flex flex-col sm:flex-row gap-3 max-w-md"
              onSubmit={(e) => e.preventDefault()}
            >
              <label htmlFor="footer-email" className="sr-only">
                Email address
              </label>
              <input
                id="footer-email"
                type="email"
                required
                placeholder="your.email@example.com"
                className="flex-grow px-4 py-3 rounded-md border border-blue-800 bg-[#0A223C] text-blue-100 placeholder-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200"
              />
              <button
                type="submit"
                className="bg-gradient-to-r from-blue-600 to-indigo-700 hover:scale-105 rounded-md px-6 py-3 font-semibold text-white transition-transform duration-200 focus:outline-none focus:ring-4 focus:ring-blue-400/50"
              >
                Subscribe
              </button>
            </form>
          </div>

          <FooterLinkColumn title="Support" links={footerLinks.support} />
          <FooterLinkColumn title="Services" links={footerLinks.services} />

          <ContactInfo details={contactDetails} />
        </div>

        <div className="mt-16 border-t border-blue-900/60 pt-8 text-sm text-blue-300 text-center space-y-2">
          <p className="flex items-center justify-center gap-2">
            <Copyright size={16} />
            {currentYear} Drone Planet. All Rights Reserved.
          </p>
          <p className="flex items-center justify-center gap-2">
            <Building size={16} />A Product of{" "}
            <a
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-blue-200 hover:text-white transition-colors"
            >
              SPH Aviation
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
